import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { GdprAutoConsentEffects } from './gdpr-auto-consent.effects';
import { GdprAutoConsentNamespace, GdprAutoConsentReducer } from './gdpr-auto-consent.store';

@NgModule({
  imports: [
    StoreModule.forFeature(GdprAutoConsentNamespace, GdprAutoConsentReducer),
    EffectsModule.forFeature([GdprAutoConsentEffects]),
  ],
})
export class GdprAutoConsentDataModule {}
